export const remainingEstimateViewTestId = 'issue-field-remaining-estimate.ui.view';
